import { LOCALE_ID, NgModule } from '@angular/core';
import { AppToastrService } from './services/app-toastr.service';
import { ToastrService } from 'ngx-toastr';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { MatMenuModule } from "@angular/material/menu";
import { FullCalendarModule } from "@fullcalendar/angular";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { DatePipe } from "@angular/common";
import { NgxEditorModule } from "ngx-editor";
import { CarouselModule } from "ngx-owl-carousel-o";
import { MatCardModule } from "@angular/material/card";
import { NgScrollbarModule } from "ngx-scrollbar";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { NgApexchartsModule } from "ng-apexcharts";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatButtonModule } from "@angular/material/button";
import { MatNativeDateModule } from "@angular/material/core";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatBadgeModule } from "@angular/material/badge";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatRippleModule } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
// MatSnackBarModule removed — using ngx-toastr
import { MatSortModule } from "@angular/material/sort";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTreeModule } from "@angular/material/tree";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { CdkAccordionModule } from "@angular/cdk/accordion";
import { NgxEchartsModule } from "ngx-echarts";
import { NgxGaugeModule } from "ngx-gauge";
import { NgChartsModule } from "ng2-charts";
import { NgxMatTimepickerModule } from "ngx-mat-timepicker";
import { QuillModule } from "ngx-quill";
import { ColorPickerModule } from "ngx-color-picker";
import { NgxDropzoneModule } from "ngx-dropzone";
import { NgSelectModule } from '@ng-select/ng-select';
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SidebarComponent } from "./components/common/sidebar/sidebar.component";
import { FooterComponent } from "./components/common/footer/footer.component";
import { HeaderComponent } from "./components/common/header/header.component";
import { ButtonsComponent } from "./components/ui-kit/buttons/buttons.component";
import { AlertsComponent } from "./components/ui-kit/alerts/alerts.component";
import { AvatarsComponent } from "./components/ui-kit/avatars/avatars.component";
import { BadgesComponent } from "./components/ui-kit/badges/badges.component";
import { CardsComponent } from "./components/ui-kit/cards/cards.component";
import { CarouselsComponent } from "./components/ui-kit/carousels/carousels.component";
import { MenusComponent } from "./components/ui-kit/menus/menus.component";
import { GridComponent } from "./components/ui-kit/grid/grid.component";
import { ImagesComponent } from "./components/ui-kit/images/images.component";
import { ListComponent } from "./components/ui-kit/list/list.component";
import { AutocompleteComponent } from "./components/ui-kit/autocomplete/autocomplete.component";
import { DsAutocompleteComponent } from "./components/ui-kit/autocomplete/ds-autocomplete/ds-autocomplete.component";
import { FilterAutocompleteComponent } from "./components/ui-kit/autocomplete/filter-autocomplete/filter-autocomplete.component";
import { OgAutocompleteComponent } from "./components/ui-kit/autocomplete/og-autocomplete/og-autocomplete.component";
import { AutocompleteOverviewComponent } from "./components/ui-kit/autocomplete/autocomplete-overview/autocomplete-overview.component";
import { PiAutocompleteComponent } from "./components/ui-kit/autocomplete/pi-autocomplete/pi-autocomplete.component";
import { SimpleAutocompleteComponent } from "./components/ui-kit/autocomplete/simple-autocomplete/simple-autocomplete.component";
import { CheckboxComponent } from "./components/ui-kit/checkbox/checkbox.component";
import { RadioComponent } from "./components/ui-kit/radio/radio.component";
import { ButtonToggleComponent } from "./components/ui-kit/button-toggle/button-toggle.component";
import { ChipsComponent } from "./components/ui-kit/chips/chips.component";
import { ChipsAutocompleteComponent } from "./components/ui-kit/chips/chips-autocomplete/chips-autocomplete.component";
import { ChipsDadComponent } from "./components/ui-kit/chips/chips-dad/chips-dad.component";
import { ChipsWithFcComponent } from "./components/ui-kit/chips/chips-with-fc/chips-with-fc.component";
import { ChipsWithInputComponent } from "./components/ui-kit/chips/chips-with-input/chips-with-input.component";
import { StackedChipsComponent } from "./components/ui-kit/chips/stacked-chips/stacked-chips.component";
import { DatepickerComponent } from "./components/ui-kit/datepicker/datepicker.component";
import { DatepickerSvComponent } from "./components/ui-kit/datepicker/datepicker-sv/datepicker-sv.component";
import { DatepickerYmPickerComponent } from "./components/ui-kit/datepicker/datepicker-ym-picker/datepicker-ym-picker.component";
import { DateRangePcrComponent } from "./components/ui-kit/datepicker/date-range-pcr/date-range-pcr.component";
import { DateRangePfiComponent } from "./components/ui-kit/datepicker/date-range-pfi/date-range-pfi.component";
import { BasicDateRangeComponent } from "./components/ui-kit/datepicker/basic-date-range/basic-date-range.component";
import { DpActionButtonComponent } from "./components/ui-kit/datepicker/dp-action-button/dp-action-button.component";
import { DpOpenMethodComponent } from "./components/ui-kit/datepicker/dp-open-method/dp-open-method.component";
import { DatepickerPcComponent } from "./components/ui-kit/datepicker/datepicker-pc/datepicker-pc.component";
import { DatepickerCustomIconComponent } from "./components/ui-kit/datepicker/datepicker-custom-icon/datepicker-custom-icon.component";
import { DisabledDatepickerComponent } from "./components/ui-kit/datepicker/disabled-datepicker/disabled-datepicker.component";
import { DatepickerInlineCalendarComponent } from "./components/ui-kit/datepicker/datepicker-inline-calendar/datepicker-inline-calendar.component";
import { DividerComponent } from "./components/ui-kit/divider/divider.component";
import { ExpansionComponent } from "./components/ui-kit/expansion/expansion.component";
import { AccordionTogglesComponent } from "./components/ui-kit/expansion/accordion-toggles/accordion-toggles.component";
import { FormFieldComponent } from "./components/ui-kit/form-field/form-field.component";
import { FfWithLabelComponent } from "./components/ui-kit/form-field/ff-with-label/ff-with-label.component";
import { InputComponent } from "./components/ui-kit/input/input.component";
import { PaginationComponent } from "./components/ui-kit/pagination/pagination.component";
import { ProgressBarComponent } from "./components/ui-kit/progress-bar/progress-bar.component";
import { SelectComponent } from "./components/ui-kit/select/select.component";
import { SidenavComponent } from "./components/ui-kit/sidenav/sidenav.component";
import { DrawerEbsComponent } from "./components/ui-kit/sidenav/drawer-ebs/drawer-ebs.component";
import { SlideToggleComponent } from "./components/ui-kit/slide-toggle/slide-toggle.component";
import { SliderComponent } from "./components/ui-kit/slider/slider.component";
import { SnackbarComponent } from "./components/ui-kit/snackbar/snackbar.component";
import { SnackbarWithCcComponent } from "./components/ui-kit/snackbar/snackbar-with-cc/snackbar-with-cc.component";
import { SnackbarWithCpComponent } from "./components/ui-kit/snackbar/snackbar-with-cp/snackbar-with-cp.component";
import { ToolbarComponent } from "./components/ui-kit/toolbar/toolbar.component";
import { TooltipComponent } from "./components/ui-kit/tooltip/tooltip.component";
import { TooltipShowHideDelayComponent } from "./components/ui-kit/tooltip/tooltip-show-hide-delay/tooltip-show-hide-delay.component";
import { TreeComponent } from "./components/ui-kit/tree/tree.component";
import { TreeWithPldComponent } from "./components/ui-kit/tree/tree-with-pld/tree-with-pld.component";
import { TreeWithDdComponent } from "./components/ui-kit/tree/tree-with-dd/tree-with-dd.component";
import { TreeWithCheckboxComponent } from "./components/ui-kit/tree/tree-with-checkbox/tree-with-checkbox.component";
import { TabsComponent } from "./components/ui-kit/tabs/tabs.component";
import { StepperComponent } from "./components/ui-kit/stepper/stepper.component";
import { StepperResponsiveComponent } from "./components/ui-kit/stepper/stepper-responsive/stepper-responsive.component";
import { AccordionComponent } from "./components/ui-kit/accordion/accordion.component";
import { ListboxComponent } from "./components/ui-kit/listbox/listbox.component";
import { BreadcrumbComponent } from "./components/ui-kit/breadcrumb/breadcrumb.component";
import { TableComponent } from "./components/ui-kit/table/table.component";
import { DialogComponent } from "./components/ui-kit/dialog/dialog.component";
import { TypographyComponent } from "./components/ui-kit/typography/typography.component";
import { SpacingComponent } from "./components/ui-kit/spacing/spacing.component";
import { ApexchartsComponent } from "./components/charts/apexcharts/apexcharts.component";
import { DashedLineChartComponent } from "./components/charts/apexcharts/dashed-line-chart/dashed-line-chart.component";
import { GradientLineChartComponent } from "./components/charts/apexcharts/gradient-line-chart/gradient-line-chart.component";
import { ZoomableLineChartComponent } from "./components/charts/apexcharts/zoomable-line-chart/zoomable-line-chart.component";
import { BasicLineChartComponent } from "./components/charts/apexcharts/basic-line-chart/basic-line-chart.component";
import { SteplineLineChartComponent } from "./components/charts/apexcharts/stepline-line-chart/stepline-line-chart.component";
import { BrushLineChartComponent } from "./components/charts/apexcharts/brush-line-chart/brush-line-chart.component";
import { SyncingLineChartComponent } from "./components/charts/apexcharts/syncing-line-chart/syncing-line-chart.component";
import { BasicAreaChartComponent } from "./components/charts/apexcharts/basic-area-chart/basic-area-chart.component";
import { SplineAreaChartComponent } from "./components/charts/apexcharts/spline-area-chart/spline-area-chart.component";
import { DatetimeAreaChartComponent } from "./components/charts/apexcharts/datetime-area-chart/datetime-area-chart.component";
import { NegativeAreaChartComponent } from "./components/charts/apexcharts/negative-area-chart/negative-area-chart.component";
import { StackedAreaChartComponent } from "./components/charts/apexcharts/stacked-area-chart/stacked-area-chart.component";
import { MissingAreaChartComponent } from "./components/charts/apexcharts/missing-area-chart/missing-area-chart.component";
import { GithubAreaChartComponent } from "./components/charts/apexcharts/github-area-chart/github-area-chart.component";
import { BasicColumnChartComponent } from "./components/charts/apexcharts/basic-column-chart/basic-column-chart.component";
import { DatalabelsColumnChartComponent } from "./components/charts/apexcharts/datalabels-column-chart/datalabels-column-chart.component";
import { StackedColumnChartComponent } from "./components/charts/apexcharts/stacked-column-chart/stacked-column-chart.component";
import { RangeColumnChartComponent } from "./components/charts/apexcharts/range-column-chart/range-column-chart.component";
import { RotatedLabelsColumnChartComponent } from "./components/charts/apexcharts/rotated-labels-column-chart/rotated-labels-column-chart.component";
import { DistributedColumnChartComponent } from "./components/charts/apexcharts/distributed-column-chart/distributed-column-chart.component";
import { LineColumnChartComponent } from "./components/charts/apexcharts/line-column-chart/line-column-chart.component";
import { MultipleYaxisChartComponent } from "./components/charts/apexcharts/multiple-yaxis-chart/multiple-yaxis-chart.component";
import { LineAreaChartComponent } from "./components/charts/apexcharts/line-area-chart/line-area-chart.component";
import { LineColumnAreaChartComponent } from "./components/charts/apexcharts/line-column-area-chart/line-column-area-chart.component";
import { BasicRangeAreaChartComponent } from "./components/charts/apexcharts/basic-range-area-chart/basic-range-area-chart.component";
import { BasicTimelineChartComponent } from "./components/charts/apexcharts/basic-timeline-chart/basic-timeline-chart.component";
import { BasicCandlestickChartComponent } from "./components/charts/apexcharts/basic-candlestick-chart/basic-candlestick-chart.component";
import { BasicBoxplotChartComponent } from "./components/charts/apexcharts/basic-boxplot-chart/basic-boxplot-chart.component";
import { BasicBubbleChartComponent } from "./components/charts/apexcharts/basic-bubble-chart/basic-bubble-chart.component";
import { BasicScatterChartComponent } from "./components/charts/apexcharts/basic-scatter-chart/basic-scatter-chart.component";
import { BasicHeatmapChartComponent } from "./components/charts/apexcharts/basic-heatmap-chart/basic-heatmap-chart.component";
import { BasicTreemapChartComponent } from "./components/charts/apexcharts/basic-treemap-chart/basic-treemap-chart.component";
import { BasicPieChartComponent } from "./components/charts/apexcharts/basic-pie-chart/basic-pie-chart.component";
import { PieDonutChartComponent } from "./components/charts/apexcharts/pie-donut-chart/pie-donut-chart.component";
import { PieMonochromeChartComponent } from "./components/charts/apexcharts/pie-monochrome-chart/pie-monochrome-chart.component";
import { BasicRadialbarChartComponent } from "./components/charts/apexcharts/basic-radialbar-chart/basic-radialbar-chart.component";
import { MultipleRadialbarChartComponent } from "./components/charts/apexcharts/multiple-radialbar-chart/multiple-radialbar-chart.component";
import { CircleRadialbarChartComponent } from "./components/charts/apexcharts/circle-radialbar-chart/circle-radialbar-chart.component";
import { GradientRadialbarChartComponent } from "./components/charts/apexcharts/gradient-radialbar-chart/gradient-radialbar-chart.component";
import { StrokedRadialbarChartComponent } from "./components/charts/apexcharts/stroked-radialbar-chart/stroked-radialbar-chart.component";
import { CircularRadialbarChartComponent } from "./components/charts/apexcharts/circular-radialbar-chart/circular-radialbar-chart.component";
import { BasicRadarChartComponent } from "./components/charts/apexcharts/basic-radar-chart/basic-radar-chart.component";
import { MultipleRadarChartComponent } from "./components/charts/apexcharts/multiple-radar-chart/multiple-radar-chart.component";
import { PolygonRadarChartComponent } from "./components/charts/apexcharts/polygon-radar-chart/polygon-radar-chart.component";
import { BasicPolarChartComponent } from "./components/charts/apexcharts/basic-polar-chart/basic-polar-chart.component";
import { MonochromePolarChartComponent } from "./components/charts/apexcharts/monochrome-polar-chart/monochrome-polar-chart.component";
import { EchartsComponent } from "./components/charts/echarts/echarts.component";
import { SimpleEchartComponent } from "./components/charts/echarts/simple-echart/simple-echart.component";
import { EventsEchartComponent } from "./components/charts/echarts/events-echart/events-echart.component";
import { ThemeEchartComponent } from "./components/charts/echarts/theme-echart/theme-echart.component";
import { LoadingEchartComponent } from "./components/charts/echarts/loading-echart/loading-echart.component";
import { MergeEchartComponent } from "./components/charts/echarts/merge-echart/merge-echart.component";
import { InitOptsEchartComponent } from "./components/charts/echarts/init-opts-echart/init-opts-echart.component";
import { InstanceEchartComponent } from "./components/charts/echarts/instance-echart/instance-echart.component";
import { GaugeComponent } from "./components/charts/gauge/gauge.component";
import { ChartjsComponent } from "./components/charts/chartjs/chartjs.component";
import { BarChartjsComponent } from "./components/charts/chartjs/bar-chartjs/bar-chartjs.component";
import { DoughnutChartjsComponent } from "./components/charts/chartjs/doughnut-chartjs/doughnut-chartjs.component";
import { RadarChartjsComponent } from "./components/charts/chartjs/radar-chartjs/radar-chartjs.component";
import { PieChartjsComponent } from "./components/charts/chartjs/pie-chartjs/pie-chartjs.component";
import { PolarChartjsComponent } from "./components/charts/chartjs/polar-chartjs/polar-chartjs.component";
import { BubbleChartjsComponent } from "./components/charts/chartjs/bubble-chartjs/bubble-chartjs.component";
import { ScatterChartjsComponent } from "./components/charts/chartjs/scatter-chartjs/scatter-chartjs.component";
import { DragDropComponent } from "./components/ui-kit/drag-drop/drag-drop.component";
import { ConnectedSortingDdComponent } from "./components/ui-kit/drag-drop/connected-sorting-dd/connected-sorting-dd.component";
import { ColorPickerComponent } from "./components/ui-kit/color-picker/color-picker.component";
import { NotFoundComponent } from "./components/common/not-found/not-found.component";
import { InternalErrorComponent } from "./components/common/internal-error/internal-error.component";
import { ConnectionBannerComponent } from "./components/common/connection-banner/connection-banner.component";
import { AlgoTradingBannerComponent } from "./components/common/algo-trading-banner/algo-trading-banner.component";
import { ConnectionStatusInterceptor } from "./interceptors/connection-status.interceptor";
import { SessionInterceptor } from "./interceptors/session.interceptor";
import { LoginComponent } from "./components/authentication/login/login.component";
import { LogoutComponent } from "./components/authentication/logout/logout.component";
import { ForgotPasswordComponent } from "./components/authentication/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./components/authentication/reset-password/reset-password.component";
import { AddRemoveArrayBasedDatasourceTableComponent } from "./components/ui-kit/table/add-remove-array-based-datasource-table/add-remove-array-based-datasource-table.component";
import { TableDynamicallyColumnsDisplayedComponent } from "./components/ui-kit/table/table-dynamically-columns-displayed/table-dynamically-columns-displayed.component";
import { StylingColumnsTableComponent } from "./components/ui-kit/table/styling-columns-table/styling-columns-table.component";
import { AddRemoveObservableBasedDatasourceTableComponent } from "./components/ui-kit/table/add-remove-observable-based-datasource-table/add-remove-observable-based-datasource-table.component";
import { ExpandableRowsTableComponent } from "./components/ui-kit/table/expandable-rows-table/expandable-rows-table.component";
import { FilteringTableComponent } from "./components/ui-kit/table/filtering-table/filtering-table.component";
import { FooterRowTableComponent } from "./components/ui-kit/table/footer-row-table/footer-row-table.component";
import { RetrievingDataHttpTableComponent } from "./components/ui-kit/table/retrieving-data-http-table/retrieving-data-http-table.component";
import { MultipleHeaderFooterTableComponent } from "./components/ui-kit/table/multiple-header-footer-table/multiple-header-footer-table.component";
import { SortingPaginationFilteringTableComponent } from "./components/ui-kit/table/sorting-pagination-filtering-table/sorting-pagination-filtering-table.component";
import { PaginationTableComponent } from "./components/ui-kit/table/pagination-table/pagination-table.component";
import { SelectionTableComponent } from "./components/ui-kit/table/selection-table/selection-table.component";
import { SortingTableComponent } from "./components/ui-kit/table/sorting-table/sorting-table.component";
import { StickyColumnsTableComponent } from "./components/ui-kit/table/sticky-columns-table/sticky-columns-table.component";
import { StickyFooterTableComponent } from "./components/ui-kit/table/sticky-footer-table/sticky-footer-table.component";
import { StickyHeaderTableComponent } from "./components/ui-kit/table/sticky-header-table/sticky-header-table.component";
import { RippleTableComponent } from "./components/ui-kit/table/ripple-table/ripple-table.component";
import { MenuDialogComponent } from "./components/ui-kit/dialog/menu-dialog/menu-dialog.component";
import { FormDialogComponent } from "./components/ui-kit/dialog/form-dialog/form-dialog.component";
import { BigFormDialogComponent } from "./components/ui-kit/dialog/big-form-dialog/big-form-dialog.component";
import { VideosComponent } from "./components/ui-kit/videos/videos.component";
import { YoutubePopupComponent } from "./components/ui-kit/videos/youtube-popup/youtube-popup.component";
import { VimeoPopupComponent } from "./components/ui-kit/videos/vimeo-popup/vimeo-popup.component";
import { CryptoComponent } from "./components/dashboard/crypto/crypto.component";
import { CryptoStatsComponent } from "./components/dashboard/crypto/crypto-stats/crypto-stats.component";
import { MarketGraphComponent } from "./components/dashboard/crypto/market-graph/market-graph.component";
import { CurrentRateComponent } from "./components/dashboard/crypto/current-rate/current-rate.component";
import { CryptoMyProfileComponent } from "./components/dashboard/crypto/crypto-my-profile/crypto-my-profile.component";
import { UserActivitiesComponent } from "./components/dashboard/crypto/user-activities/user-activities.component";
import { OrderActivitiesComponent } from "./components/dashboard/crypto/order-activities/order-activities.component";
import { MyCurrenciesComponent } from "./components/dashboard/crypto/my-currencies/my-currencies.component";
import { TradingComponent } from "./components/dashboard/crypto/trading/trading.component";
// CustomSnackbarComponent removed; using ToastrService instead
import { ModelsComponent } from "./components/models/models.component";
import { PlanificadorGestionComponent } from "./components/models/gestion/gestion.component";
import { IndicatorsComponent } from "./components/models/indicators/indicators.component";
import { LiquidatingValuesComponent } from "./components/models/liquidating-values/liquidating-values.component";
import { OperationsComponent } from "./components/models/operations/operations.component";
import { SseService } from "./services/SseService";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { DataTablesModule } from "angular-datatables";
import { TableVirtualScrollModule  } from 'ng-table-virtual-scroll';
import { CdkTableModule } from '@angular/cdk/table';
import { RendimientoriesgoComponent } from './components/rendimientoriesgo/rendimientoriesgo.component';
import { CarteraComponent } from './components/cartera/cartera.component';
import { PosicionesBrokerComponent } from './components/cartera/posiciones-broker/posiciones-broker.component';
import { ListaOrdenesComponent } from './components/cartera/lista-ordenes/lista-ordenes.component';
import { OperacionesMtComponent } from './components/cartera/operaciones-mt/operaciones-mt.component';
import { VallatentesComponent } from './components/vallatentes/vallatentes.component';
import { GraficaRendimientoComponent } from './components/graficas/grafica-rendimiento/grafica-rendimiento.component';
import { GraficaModeloComponent } from './components/graficas/grafica-modelo/grafica-modelo.component';
import { CdkMenuModule } from '@angular/cdk/menu';
import { OverlayModule } from '@angular/cdk/overlay';
import { SepararValoresPipe } from './services/separar-valores.pipe';
import { DialogNameComponent } from './components/dialog-name/dialog-name.component';
import { ListaModeloComponent } from './components/diversificador/lista-modelo/lista-modelo.component';
import { DiversificadorService } from './services/diversificador.services';
import { GestorDialogComponent } from './components/gestor/gestor-dialog/gestor-dialog.component';
import { GestorComponent } from './components/gestor/gestor.component';
import { TablamercadoComponent } from './components/tablamercado/tablamercado.component';
import { GestionService } from './services/gestion.services';
import { ReconfiguracionDialogComponent } from './components/reconfiguracion-dialog/reconfiguracion-dialog.component';
import { OpeentradaDialogComponent } from './components/broker/opeentrada-dialog/opeentrada-dialog.component';
import { OpesalidaDialogComponent } from './components/broker/opesalida-dialog/opesalida-dialog.component';
import { CotizacionFuenteComponent } from './components/broker/cotizacion-fuente/cotizacion-fuente.component';
import { RealTimeService } from './services/realtime.service';
import { TemaService } from './services/tema.services';
import { EliminaropeDialogComponent } from './components/eliminarope-dialog/eliminarope-dialog.component';
import { DiversificadorComponent } from './components/diversificador/diversificador.component';
import { BrokerComponent } from './components/broker/broker.component';
import { AnalisisDataComponent } from './components/analisis-data/analisis-data.component';
import { AdminComponent } from "./components/admin/admin.component";
import { AdminUsuarioComponent } from './components/admin/admin-usuario/admin-usuario.component';
import { AdminUsuariosChatComponent } from './components/admin/admin-usuarios-chat/admin-usuarios-chat.component';
import { AdminMetaapiCuentasComponent } from './components/admin/admin-metaapi-cuentas/admin-metaapi-cuentas.component';
import { AdminPeriodosHistoricoComponent } from './components/admin/admin-periodos-historico/admin-periodos-historico.component';
import { AdminIaUsoComponent } from './components/admin/admin-ia-uso/admin-ia-uso.component';
import { GraficaAnalisisComponent } from './components/graficas/grafica-analisis/grafica-analisis.component';
import { DescripcionGeneralComponent } from './components/analisis/descripcion-general/descripcion-general.component';
import { PresentacionesComponent } from './components/analisis/presentaciones/presentaciones.component';
import { NoticiasComponent } from './components/analisis/noticias/noticias.component';
import { SuscripcionesComponent } from "./components/suscripciones/suscripciones.component";
import { SuscripcionesConfirmarComponent } from "./components/broker/suscripciones-confirmar/suscripciones-confirmar.component";
import { MultichartsDialogComponent } from "./components/broker/multicharts-dialog/multicharts-dialog.component";
import { ToastrModule } from 'ngx-toastr';
import { DatosHistoricosComponent } from './components/analisis/datos-historicos/datos-historicos.component';
import { EstadosFinancierosComponent } from "./components/analisis/estados-financieros/estados-financieros.component";
import { DataTablaComponent } from "./components/analisis/data-tabla/data-tabla.component";
import { SeguimientoCarterasComponent } from "./components/seguimiento-carteras/seguimiento-carteras.component";
import { BuscadorComponent } from "./components/buscador/buscador.component";
import { LoginDialogComponent } from "./components/broker/login-dialog/login-dialog.component";
import { RastreadorComponent } from "./components/rastreador/rastreador.component";
import { TablaVolatilidadComponent } from "./components/rastreador/data-rastreador/tabla-volatilidad/tabla-volatilidad.component";
import { TablaCompaniaComponent } from "./components/rastreador/data-rastreador/tabla-compania/tabla-compania.component";
import { AnalisisEstadisticoComponent } from "./components/rastreador/data-rastreador/analisis-estadistico/analisis-estadistico.component";
import { DialogClasificacionComponent } from "./components/rastreador/data-rastreador/dialog-clasificacion/dialog-clasificacion.component";
import { DialogExclusionComponent } from "./components/rastreador/data-rastreador/dialog-exclusion/dialog-exclusion.component";
import { EstudioEarningComponent } from "./components/rastreador/data-rastreador/estudio-earning/estudio-earning.component";
import { ConfirmDialogComponent } from "./components/common/confirm-dialog/confirm-dialog.component";
import { NotificacionDetalleDialogComponent } from "./components/common/notificacion-detalle-dialog/notificacion-detalle-dialog.component";
import { GestionListasComponent} from "./components/gestion-listas/gestion-listas.component";
import { BrokerOpDialogComponent } from "./components/broker/broker-op-dialog/broker-op-dialog.component";
import { SincronizarComparativaDialogComponent } from "./components/broker/sincronizar-comparativa-dialog/sincronizar-comparativa-dialog.component";
import { SalirFinDiaDialogComponent } from "./components/broker/salir-fin-dia-dialog/salir-fin-dia-dialog.component";
import { CerrarPosicionComponent } from "./components/broker/cerrar-posicion/cerrar-posicion.component";
import { ListaCompaniaComponent } from "./components/gestion-listas/lista-compania/lista-compania.component";
import { EliminarListaComponent } from "./components/gestion-listas/eliminar-lista/eliminar-lista.component";
import { InformeComponent } from "./components/informe/informe.component";
import { EditarOrdenComponent } from "./components/broker/editar-orden/editar-orden.component";
import { GestorModeloDialogComponent } from "./components/gestor/gestor-modelo-dialog/gestor-modelo-dialog.component";
import { VernotificacionesComponent } from "./components/vernotificaciones/vernotificaciones.component";
import { IboauthComponent } from "./components/broker/login-dialog/iboauth/iboauth.component";
import { MentionModule } from 'angular-mentions';
import { TablacondicionesComponent } from "./components/tablacondiciones/tablacondiciones.component";
import { CdkSelectComponent } from "./cdk-select/cdk-select.component";
import { DialogIndicadoresComponent } from "./components/dialog-indicadores/dialog-indicadores.component";
import { StockComponent } from './components/stock/stock.component';
import { StrategyFactoryComponent } from "./components/strategy-factory/strategy-factory.component";
import { MercadoSelectComponent } from "./components/common/mercado-select/mercado-select.component";
import { CondicionesComponent } from "./components/condiciones/condiciones.component";
import { AnalisisPeriodosComponent } from './components/analisis-periodos/analisis-periodos.component';
import { CrearModeloComponent } from "./components/crear-modelo/crear-modelo.component";
import { DialogGuardarComponent } from './components/dialog-guardar/dialog-guardar.component';
import { ChatIaDialogComponent } from './components/chat-ia-dialog/chat-ia-dialog.component';
import { StrategyFactoryResultsTableComponent } from './components/strategy-factory/results-table/results-table.component';
import { DialogCondicionComponent } from './components/condiciones/dialog-condicion/dialog-condicion.component';
import { DialogConfirmacionComponent } from './components/dialog-confirmacion/dialog-confirmacion.component';
import { EditarListaComponent } from './components/gestion-listas/editar-lista/editar-lista.component';
import { EditarParametrosCondicionComponent } from './components/strategy-factory/editar-parametros-condicion/editar-parametros-condicion.component';
import { NumberSuffixPipe } from './shared/pipes/number-suffix.pipe';
import { SmartDatePipe } from './shared/pipes/smart-date.pipe';
import { OrigenOrdenPipe } from './shared/pipes/origen-orden.pipe';
import { HelpDialogComponent } from './components/common/help-dialog/help-dialog.component';
import { TableColResizeDirective } from './directives/table-col-resize.directive';
import { FitViewportDirective } from './directives/fit-viewport.directive';

// Drawing tools compartidas (estilo TradingView) para los charts
import { DrawingToolbarComponent } from './components/common/chart-drawing/drawing-toolbar/drawing-toolbar.component';
import { DrawingFloatingToolbarComponent } from './components/common/chart-drawing/drawing-floating-toolbar/drawing-floating-toolbar.component';
import { DrawingSettingsDialogComponent } from './components/common/chart-drawing/drawing-settings-dialog/drawing-settings-dialog.component';
import { DrawingTextDialogComponent } from './components/common/chart-drawing/drawing-text-dialog/drawing-text-dialog.component';
import { DrawingObjectTreeComponent } from './components/common/chart-drawing/drawing-object-tree/drawing-object-tree.component';

// Núcleo compartido de charts (grafica-modelo + multicharts-dialog)
import { ChartLegendComponent } from './components/common/chart-core/chart-legend/chart-legend.component';


// NEWSLETTER - Módulo 1
import { NewsletterListComponent } from './components/newsletter/newsletter-list/newsletter-list.component';
import { NewsletterEditorComponent } from './components/newsletter/newsletter-editor/newsletter-editor.component';
import { NewsletterDetailComponent } from './components/newsletter/newsletter-detail/newsletter-detail.component';
import { NewsletterTemplatesComponent } from './components/newsletter/newsletter-templates/newsletter-templates.component';

import { SocialAccountsComponent } from './components/social/social-accounts/social-accounts.component';
import { SocialEditorComponent } from './components/social/social-editor/social-editor.component';
import { SocialListComponent } from './components/social/social-list/social-list.component';
import {SocialCommentsComponent} from './components/social-comments/social-comments.component';
import { SocialReplyDialogComponent } from './components/social/dialogs/social-reply-dialog/social-reply-dialog.component';import { ProfileComponent } from './components/profile/profile.component';
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeEs);


@NgModule({
    declarations: [ NumberSuffixPipe, SmartDatePipe, OrigenOrdenPipe, HelpDialogComponent, EditarListaComponent,
        MercadoSelectComponent,
        ProfileComponent,
        TableColResizeDirective,
        FitViewportDirective,
        SocialAccountsComponent,
        SocialEditorComponent,
        SocialListComponent,
        EditarParametrosCondicionComponent,
        DialogConfirmacionComponent,
        CrearModeloComponent,
        DialogCondicionComponent,
        StrategyFactoryComponent,
        CondicionesComponent,
        AnalisisPeriodosComponent,
        TablacondicionesComponent,
        EditarOrdenComponent,
        GestorModeloDialogComponent,
        InformeComponent,
        DialogIndicadoresComponent,
        CdkSelectComponent,
        EliminarListaComponent,
        ListaCompaniaComponent,
        CerrarPosicionComponent,
        BrokerOpDialogComponent,
        SincronizarComparativaDialogComponent,
        SalirFinDiaDialogComponent,
        ConfirmDialogComponent,
        NotificacionDetalleDialogComponent,
        DrawingToolbarComponent,
        DrawingFloatingToolbarComponent,
        ChartLegendComponent,
        DrawingSettingsDialogComponent,
        DrawingTextDialogComponent,
        DrawingObjectTreeComponent,
        EstudioEarningComponent,
        DialogExclusionComponent,
        DialogClasificacionComponent,
        AnalisisEstadisticoComponent,
        TablaCompaniaComponent,
        TablaVolatilidadComponent,
        BuscadorComponent,
        RastreadorComponent,
        LoginDialogComponent,
        DataTablaComponent,
        EstadosFinancierosComponent,
        BrokerComponent,
        DatosHistoricosComponent,
        NoticiasComponent,
        PresentacionesComponent,
        DescripcionGeneralComponent,
        GraficaAnalisisComponent,
        AnalisisDataComponent,AdminComponent,
        AdminUsuarioComponent,
        AdminUsuariosChatComponent,
        AdminMetaapiCuentasComponent,
        AdminPeriodosHistoricoComponent,
        AdminIaUsoComponent,
        LoginComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        DiversificadorComponent,
        EliminaropeDialogComponent,
        OpesalidaDialogComponent,
        OpeentradaDialogComponent,
        CotizacionFuenteComponent,
        ReconfiguracionDialogComponent,
        GestorComponent,
        TablamercadoComponent,
        GestorDialogComponent,
        ListaModeloComponent,
        DialogNameComponent,
        SepararValoresPipe,
        GraficaModeloComponent,
        GraficaRendimientoComponent,
        CarteraComponent, PosicionesBrokerComponent, ListaOrdenesComponent, OperacionesMtComponent,
        VallatentesComponent,
        RendimientoriesgoComponent,
        PlanificadorGestionComponent,
        ModelsComponent,
        OperationsComponent,
        AppComponent,
        DashboardComponent,
        SidebarComponent,
        FooterComponent,
        HeaderComponent,
        ButtonsComponent,
        AlertsComponent,
        AvatarsComponent,
        BadgesComponent,
        CardsComponent,
        CarouselsComponent,
        MenusComponent,
        GridComponent,
        ImagesComponent,
        ListComponent,
        AutocompleteComponent,
        DsAutocompleteComponent,
        FilterAutocompleteComponent,
        OgAutocompleteComponent,
        AutocompleteOverviewComponent,
        PiAutocompleteComponent,
        SimpleAutocompleteComponent,
        CheckboxComponent,
        RadioComponent,
        ButtonToggleComponent,
        ChipsComponent,
        ChipsAutocompleteComponent,
        ChipsDadComponent,
        ChipsWithFcComponent,
        ChipsWithInputComponent,
        StackedChipsComponent,
        DatepickerComponent,
        DatepickerSvComponent,
        DatepickerYmPickerComponent,
        DateRangePcrComponent,
        DateRangePfiComponent,
        BasicDateRangeComponent,
        DpActionButtonComponent,
        DpOpenMethodComponent,
        DatepickerPcComponent,
        DatepickerCustomIconComponent,
        DisabledDatepickerComponent,
        DatepickerInlineCalendarComponent,
        DividerComponent,
        ExpansionComponent,
        AccordionTogglesComponent,
        FormFieldComponent,
        FfWithLabelComponent,
        InputComponent,
        PaginationComponent,
        ProgressBarComponent,
        SelectComponent,
        SidenavComponent,
        DrawerEbsComponent,
        SlideToggleComponent,
        SliderComponent,
        SnackbarComponent,
        SnackbarWithCcComponent,
        SnackbarWithCpComponent,
        ToolbarComponent,
        TooltipComponent,
        TooltipShowHideDelayComponent,
        TreeComponent,
        TreeWithPldComponent,
        TreeWithDdComponent,
        TreeWithCheckboxComponent,
        TabsComponent,
        StepperComponent,
        StepperResponsiveComponent,
        AccordionComponent,
        ListboxComponent,
        BreadcrumbComponent,
        TableComponent,
        DialogComponent,
        TypographyComponent,
        SpacingComponent,
        ApexchartsComponent,
        DashedLineChartComponent,
        GradientLineChartComponent,
        ZoomableLineChartComponent,
        BasicLineChartComponent,
        SteplineLineChartComponent,
        BrushLineChartComponent,
        SyncingLineChartComponent,
        BasicAreaChartComponent,
        SplineAreaChartComponent,
        DatetimeAreaChartComponent,
        NegativeAreaChartComponent,
        StackedAreaChartComponent,
        MissingAreaChartComponent,
        GithubAreaChartComponent,
        BasicColumnChartComponent,
        DatalabelsColumnChartComponent,
        StackedColumnChartComponent,
        RangeColumnChartComponent,
        RotatedLabelsColumnChartComponent,
        DistributedColumnChartComponent,
        LineColumnChartComponent,
        MultipleYaxisChartComponent,
        LineAreaChartComponent,
        LineColumnAreaChartComponent,
        BasicRangeAreaChartComponent,
        BasicTimelineChartComponent,
        BasicCandlestickChartComponent,
        BasicBoxplotChartComponent,
        BasicBubbleChartComponent,
        BasicScatterChartComponent,
        BasicHeatmapChartComponent,
        BasicTreemapChartComponent,
        BasicPieChartComponent,
        PieDonutChartComponent,
        PieMonochromeChartComponent,
        BasicRadialbarChartComponent,
        MultipleRadialbarChartComponent,
        CircleRadialbarChartComponent,
        GradientRadialbarChartComponent,
        StrokedRadialbarChartComponent,
        CircularRadialbarChartComponent,
        BasicRadarChartComponent,
        MultipleRadarChartComponent,
        PolygonRadarChartComponent,
        BasicPolarChartComponent,
        MonochromePolarChartComponent,
        EchartsComponent,
        SimpleEchartComponent,
        EventsEchartComponent,
        ThemeEchartComponent,
        LoadingEchartComponent,
        MergeEchartComponent,
        InitOptsEchartComponent,
        InstanceEchartComponent,
        GaugeComponent,
        ChartjsComponent,
        BarChartjsComponent,
        DoughnutChartjsComponent,
        RadarChartjsComponent,
        PieChartjsComponent,
        PolarChartjsComponent,
        BubbleChartjsComponent,
        ScatterChartjsComponent,
        DragDropComponent,
        ConnectedSortingDdComponent,
        ColorPickerComponent,
        NotFoundComponent,
        InternalErrorComponent,
        ConnectionBannerComponent,
        AlgoTradingBannerComponent,
        LogoutComponent,
        AddRemoveArrayBasedDatasourceTableComponent,
        TableDynamicallyColumnsDisplayedComponent,
        StylingColumnsTableComponent,
        AddRemoveObservableBasedDatasourceTableComponent,
        ExpandableRowsTableComponent,
        FilteringTableComponent,
        FooterRowTableComponent,
        RetrievingDataHttpTableComponent,
        MultipleHeaderFooterTableComponent,
        SortingPaginationFilteringTableComponent,
        PaginationTableComponent,
        SelectionTableComponent,
        SortingTableComponent,
        StickyColumnsTableComponent,
        StickyFooterTableComponent,
        StickyHeaderTableComponent,
        RippleTableComponent,
        MenuDialogComponent,
        FormDialogComponent,
        BigFormDialogComponent,
        VideosComponent,
        YoutubePopupComponent,
        VimeoPopupComponent,
        CryptoComponent,
        CryptoStatsComponent,
        MarketGraphComponent,
        CurrentRateComponent,
        CryptoMyProfileComponent,
        UserActivitiesComponent,
        OrderActivitiesComponent,
        MyCurrenciesComponent,
        TradingComponent,
        IndicatorsComponent,
        LiquidatingValuesComponent,
        SuscripcionesComponent, SuscripcionesConfirmarComponent, MultichartsDialogComponent,
        SeguimientoCarterasComponent,GestionListasComponent,VernotificacionesComponent,IboauthComponent,
        DialogGuardarComponent,
        ChatIaDialogComponent,
        StrategyFactoryResultsTableComponent,
        StockComponent,
        NewsletterListComponent,
        NewsletterEditorComponent,
        NewsletterDetailComponent,
        NewsletterTemplatesComponent,
        SocialCommentsComponent,
        SocialReplyDialogComponent
    ],
    imports: [MentionModule,
        BrowserModule,
        AppRoutingModule,
        MatMenuModule,
        MatCardModule,
        MatTableModule,
        MatPaginatorModule,
        BrowserAnimationsModule,
        NgApexchartsModule,
        MatProgressBarModule,
        MatButtonModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatSliderModule,
        // MatSnackBarModule removed
        MatSortModule,
        MatStepperModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatTreeModule,
        NgScrollbarModule,
        FormsModule,
        FullCalendarModule,
        MatNativeDateModule,
        ReactiveFormsModule,
        CarouselModule,
        NgxEditorModule,
        DragDropModule,
        HttpClientModule,
        CdkAccordionModule,
        ScrollingModule,
        NgxDatatableModule,
        DataTablesModule,
        MatPaginatorModule,
        TableVirtualScrollModule,
        CdkTableModule,
        MatProgressSpinnerModule ,
        MatMenuModule ,
        OverlayModule,
        NgxEchartsModule.forRoot({
            echarts: () => import('echarts'),
        }),
        NgSelectModule,
        NgxGaugeModule,
        NgChartsModule,
        NgxMatTimepickerModule,
        QuillModule.forRoot(),
        ColorPickerModule,
        NgxDropzoneModule,
        // CustomSnackbarComponent removed
        CdkMenuModule,
        ToastrModule.forRoot({
            closeButton: true,
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
            progressBar: true,
            preventDuplicates: true,
            countDuplicates: true,
            resetTimeoutOnDuplicate: true,
            maxOpened: 5,
        })
    ],
    providers: [{ provide: LOCALE_ID, useValue: 'es-ES' }, DatePipe, SseService, DiversificadorService, GestionService, RealTimeService, TemaService, { provide: ToastrService, useClass: AppToastrService }, { provide: HTTP_INTERCEPTORS, useClass: ConnectionStatusInterceptor, multi: true }, { provide: HTTP_INTERCEPTORS, useClass: SessionInterceptor, multi: true }],
    bootstrap: [AppComponent],
})
export class AppModule {}

